/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PatchLotConflictType {
  CannotWithdrawLotWithAcceptedPrebids = 'cannot_withdraw_lot_with_accepted_prebids'
}
